import { getDoc } from 'firebase/firestore/lite'
import refs from '../refsLite'

export async function loadChunk(sessionId, chunkId) {
  const chunkDoc = await getDoc(refs.eventLog(sessionId, chunkId))
  return chunkDoc.data()
}
